import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { DataService } from '../data.service';

/**
 *  ÜZENETEK – szálas levelezés szerepkör-szabállyal és csatolmánnyal.
 *
 *  Bal oldalon a szálak, jobb oldalon a folyam. Új üzenetnél a címzett-választó
 *  CSAK azt kínálja, akinek a belépési módommal írhatok – a szabályt a szerver is
 *  ellenőrzi, tehát a felület nem védelem, csak kényelem:
 *
 *      diák  → tanár        tanár → diák, szülő, osztály, csoport, tanár
 *      szülő → tanár        gondviselő nem ír diáknak és szülőnek
 *
 *  Válasznál nincs címzett-választó: a szál résztvevői kapják, a saját szerepköröm
 *  szerint szűrve – így egy osztálynak szóló körlevélre a diák válasza a tanárhoz
 *  megy, nem az egész osztálynak.
 */
@Component({
  selector: 'app-uzenetek',
  templateUrl: './uzenetek.component.html',
  styleUrls: ['./uzenetek.component.scss'],
})
export class UzenetekComponent implements OnInit {
  intezmenyId = '';
  felhasznalo = '';
  loginMode = '';
  toltodik = false;

  szalak: any[] = [];
  olvasatlan = 0;
  kivalasztott: any = null;      // { szal, targy, uzenetek[] }
  szuro = '';

  /*  HIVATALI KAPU MINT MÁSIK CSATORNA – adminisztrátoroknak.
   *
   *  A hivatalos küldés eddig CSAK a tömeges kiküldésen keresztül volt elérhető (köteg,
   *  partnertörzs, aláírás, iktatás). Egy darab határozathoz vagy igazoláshoz ez
   *  aránytalan, ezért a gyakorlatban e-mail ment helyette – vagyis épp a hivatalos utat
   *  kerülte meg. Itt egy küldemény adható fel: címzett, tárgy, fájl.
   *
   *  A hivatali kapu DOKUMENTUMOT továbbít, nem szöveget: ezért itt a csatolmány nem
   *  díszítés, hanem maga a küldemény – és a felület is ezt mondja.
   */
  admin = false;
  csatorna: 'belso' | 'hivatali_kapu' = 'belso';
  hkPartnerek: any[] = [];
  hkPartnerSzuro = '';
  hk: any = { partner_id: '', krid: '', cimzett_rovidnev: '', kapcsolati_kod: '', targy: '',
    iktatoszam: '' };
  hkFajl: File | null = null;
  hkEredmeny: { ok: boolean; szoveg: string } | null = null;

  // Új üzenet
  ujNyitva = false;
  uj: any = { targy: '', uzenet: '', cimzettek: [] };
  cimtar: any = { dolgozo: [], tanulo: [], gondviselo: [], osztaly: [], csoport: [], kor: [] };
  irhat: string[] = [];
  cimzettKereses = '';
  csatolando: File[] = [];
  /*  Jár-e az egész iskolának szóló kör. A kiszolgáló mondja meg, a felület csak
   *  eszerint mutatja a gombokat – tiltani úgyis a kiszolgáló tilt. */
  intezmenyiKor = false;

  /*  ÉRTEKEZLET-FELVÉTEL MEGOSZTÁSA.
   *
   *  Az Értekezlet képernyőről érkezik, a navigáció állapotában. A felvétel NEM
   *  másolódik a levélbe (több száz megabájt): a küldés után egy hivatkozás kerül rá,
   *  és a címzettek ugyanazt az egy fájlt nézik vissza. */
  megosztandoFelvetel: any = null;

  /*  ELKÜLDÖTT ÜZENET JAVÍTÁSA.
   *
   *  Csak a sajátunkat, és nem némán: a javított üzenet „szerkesztve" jelölést kap, az
   *  előző szöveg pedig naplóba kerül. Egy szülővel folytatott levelezésnél ez nem
   *  formaság – a néma átírás azt jelentené, hogy a leírtakra senki nem hivatkozhat. */
  szerkesztettId: string | null = null;
  szerkesztettSzoveg = '';
  szerkesztesFolyamatban = false;

  // Válasz
  valasz = '';
  valaszCsatolando: File[] = [];
  kuldes = false;
  // Kinek megy a válasz: mindenkinek / csak a feladónak / kiválasztottaknak.
  valaszMod: 'mind' | 'felado' | 'valasztott' = 'mind';
  valaszValasztottak: string[] = [];

  readonly tipusNev: any = {
    dolgozo: 'Munkatárs', tanulo: 'Tanuló', gondviselo: 'Gondviselő',
    osztaly: 'Osztály', csoport: 'Csoport',
    mindenki: 'Kör', dolgozok: 'Kör', tanulok: 'Kör', szulok: 'Kör',
    osztaly_szulei: 'Kör', csoport_szulei: 'Kör',
  };

  /*  Link-előnézetek cím szerint. Egy körlevélben ugyanaz a link több üzenetben is
   *  szerepelhet – így egyszer kérjük le, és a válasz is megmarad a képernyő életére. */
  private elonezetek = new Map<string, any>();

  /*  Az ÉPP ÍRT üzenetben talált első link – a szerkesztő alatti kártyához.
   *  Külön mező, nem getter: a gépelés elültéig nem indítunk lekérést. */
  ujLink: string | null = null;
  valaszLink: string | null = null;
  private linkIdozito: any = null;

  constructor(private http: HttpClient, private data: DataService, private router: Router) {}

  async ngOnInit() {
    this.intezmenyId = (await this.data.getFromStorage('sajatIntezmeny'))?.intezmenyId;
    this.loginMode = await this.data.getFromStorage('loginmode');
    const meta: any = await this.data.getFromStorage('userMetadata');
    // A dolgozó azonosítója az adid, a tanulóé az oktatási azonosító, a szülőé a felhasználónév.
    this.felhasznalo = this.loginMode === 'tanulo'
      ? String(meta?.oktazon || meta?.username || '')
      : String(meta?.adid || meta?.username || '');
    /*  A HIVATALI KAPU csatorna csak adminisztrátornak jelenik meg: hivatalos küldés,
     *  a szervezet nevében, érkeztetési számmal – ez nem napi felhasználói művelet.
     *  A kiszolgáló is ellenőriz, ez itt csak a felület. */
    try {
      const jogkor = String((await this.data.getJogkor()) || '').toLowerCase();
      this.admin = ['admin', 'rendszergazda', 'ig', 'igh', 'adminh', 'madmin'].includes(jogkor);
    } catch (e) { this.admin = false; }

    await this.betolt();
    await this.cimtarBetolt();
    this.megosztastAtvesz();
  }

  /**
   *  Az Értekezlet képernyőről „Megosztás üzenetben"-nel érkezve a levélíró nyitva
   *  fogad, a felvétellel együtt. A navigáció állapotát KIÜRÍTJÜK utána: különben egy
   *  frissítés (vagy a vissza gomb) újra felkínálná ugyanazt a felvételt.
   */
  private megosztastAtvesz() {
    const f = (history?.state as any)?.felvetel;
    if (!f?.id) return;
    this.megosztandoFelvetel = f;
    this.csatorna = 'belso';
    this.ujNyitva = true;
    const mikor = f.kezdete || f.feltoltve;
    this.uj.targy = `Értekezlet-felvétel${f.szoba ? ` – ${f.szoba}` : ''}`.slice(0, 100);
    this.uj.uzenet = 'Megosztom az értekezlet felvételét. A levélhez csatolva megtalálod, '
      + 'és itt, a rendszerben vissza is tudod nézni'
      + (mikor ? ` (${new Date(mikor).toLocaleString('hu-HU')})` : '') + '.';
    try { history.replaceState({ ...history.state, felvetel: null }, ''); } catch (e) { /* mindegy */ }
  }

  /* ── szálak ── */

  async betolt() {
    if (!this.felhasznalo) return;
    this.toltodik = true;
    try {
      const r: any = await firstValueFrom(this.http.get(
        `/api/uzenet/szalak/${this.intezmenyId}?felhasznalo=${encodeURIComponent(this.felhasznalo)}`));
      this.szalak = r?.szalak || [];
      this.olvasatlan = r?.olvasatlan || 0;
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'Az üzenetek betöltése nem sikerült.', 'error');
    } finally {
      this.toltodik = false;
    }
  }

  get szurtSzalak(): any[] {
    const sz = this.szuro.trim().toLowerCase();
    if (!sz) return this.szalak;
    // Keresés névre is, ne csak az azonosítóra – a felhasználó nevet ír be.
    return this.szalak.filter((x) =>
      (x.targy || '').toLowerCase().includes(sz)
      || (x.utolso?.uzenet || '').toLowerCase().includes(sz)
      || (x.utolso?.kuldo_nev || '').toLowerCase().includes(sz)
      || (x.resztvevo_nevek || []).some((r: string) => (r || '').toLowerCase().includes(sz))
      || (x.resztvevok || []).some((r: string) => (r || '').toLowerCase().includes(sz)));
  }

  async megnyit(sz: any) {
    try {
      this.kivalasztott = await firstValueFrom(this.http.get(
        `/api/uzenet/szal/${sz.szal}?felhasznalo=${encodeURIComponent(this.felhasznalo)}`
        + `&mod=${this.loginMode}`));
      /*  A szöveg darabjait és a linket EGYSZER számoljuk ki, a megnyitáskor. Ha ezt a
       *  sablon hívná, minden egérmozdulásnál új tömb születne: a lista újra kirajzolódna,
       *  és az előnézet villogna. */
      const rendszer = !!this.kivalasztott?.rendszer;
      for (const u of this.kivalasztott?.uzenetek || []) {
        //  A rendszer HTML-ben írt üzenete HTML-ként jelenik meg (a sablon tisztítva rajzolja).
        u._html = rendszer && UzenetekComponent.htmlE(u.uzenet);
        u._darabok = this.szovegDarabok(u._html ? '' : u.uzenet);
        u._link = u._darabok.find((d: any) => d.url)?.url || null;
      }
      this.valasz = '';
      this.valaszCsatolando = [];
      // Több résztvevőnél alapból mindenkinek megy a válasz; egy résztvevőnél a
      // választónak nincs értelme, ilyenkor is a "mind" a jó (az az egy ember).
      this.valaszMod = 'mind';
      this.valaszValasztottak = [];
      // A megnyitás olvasottra állít, ezért a listát is frissítjük.
      await this.betolt();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A szál megnyitása nem sikerült.', 'error');
    }
  }

  /* ── címtár ── */

  async cimtarBetolt() {
    try {
      const r: any = await firstValueFrom(this.http.get(
        `/api/uzenet/cimtar/${this.intezmenyId}?mod=${this.loginMode}`
        + `&felhasznalo=${encodeURIComponent(this.felhasznalo)}`));
      this.cimtar = r?.cimtar || {};
      this.intezmenyiKor = !!r?.intezmenyi_kor;
      this.irhat = r?.irhat || [];
    } catch (e: any) {
      this.irhat = [];
    }
  }

  /**
   *  A kereséshez illeszkedő címzettek, típusonként legfeljebb 15 – hogy ne dőljön ránk
   *  200 név. A KÖRÖK elöl állnak, és ÜRES kereséssel is látszanak: „minden gondviselő"-t
   *  nem tud az keresni, aki nem tudja, hogy létezik. Névre marad a két karakter.
   */
  get talalatok(): any[] {
    const sz = this.cimzettKereses.trim().toLowerCase();
    const korok = this.korTalalatok(sz);
    if (sz.length < 2) return korok;
    const bent = new Set(this.uj.cimzettek.map((c: any) => `${c.tipus}:${c.azonosito}`));
    const ki: any[] = [...korok];
    for (const tipus of this.irhat) {
      const lista = (this.cimtar[tipus] || [])
        .filter((x: any) => !bent.has(`${tipus}:${x.azonosito}`))
        .filter((x: any) => (x.nev || '').toLowerCase().includes(sz)
          || String(x.azonosito || '').toLowerCase().includes(sz)
          || (x.osztaly || '').toLowerCase().includes(sz))
        .slice(0, 15);
      ki.push(...lista);
    }
    return ki;
  }

  /*  A KÖRÖK UGYANABBAN A KERESŐBEN VANNAK, mint a nevek – nem külön gombsorban.
   *
   *  Egy címzett-választó van, nem kettő: aki címzettet keres, ne kelljen előbb
   *  eldöntenie, hogy „kör"-t vagy „embert" keres-e. Létszám nélküli kört nem kínálunk
   *  (lezárt tanév osztálya, üres csoport): az csak félreértést okozna. */
  private korTalalatok(sz: string): any[] {
    const bent = new Set(this.uj.cimzettek.map((c: any) => `${c.tipus}:${c.azonosito}`));
    return (this.cimtar?.kor || [])
      .filter((k: any) => k.db > 0)
      .filter((k: any) => !bent.has(`${k.tipus}:${k.azonosito}`))
      .filter((k: any) => !sz || `${k.nev || ''} ${k.leiras || ''}`.toLowerCase().includes(sz))
      .slice(0, 20);
  }

  /** Hány emberhez megy ki – a kör a benne lévő létszámmal számít. */
  get becsultCimzettDb(): number {
    return this.uj.cimzettek.reduce((ossz: number, c: any) => ossz + (Number(c.db) || 1), 0);
  }

  cimzettHozzaad(c: any) {
    this.uj.cimzettek = [...this.uj.cimzettek, c];
    this.cimzettKereses = '';
  }

  cimzettKivesz(c: any) {
    this.uj.cimzettek = this.uj.cimzettek.filter(
      (x: any) => !(x.tipus === c.tipus && x.azonosito === c.azonosito));
  }

  /* ── küldés ── */

  fajlValaszt(esemeny: any, hova: 'uj' | 'valasz') {
    const fajlok: File[] = Array.from(esemeny?.target?.files || []);
    if (hova === 'uj') this.csatolando = [...this.csatolando, ...fajlok];
    else this.valaszCsatolando = [...this.valaszCsatolando, ...fajlok];
    if (esemeny?.target) esemeny.target.value = '';
  }

  fajlTorol(f: File, hova: 'uj' | 'valasz') {
    if (hova === 'uj') this.csatolando = this.csatolando.filter((x) => x !== f);
    else this.valaszCsatolando = this.valaszCsatolando.filter((x) => x !== f);
  }

  /** A csatolmányok az üzenet létrejötte UTÁN mennek fel: az üzenet azonosítójához kötődnek. */
  private async csatolmanyokFeltolt(messageId: string, fajlok: File[]) {
    for (const f of fajlok) {
      const fd = new FormData();
      fd.append('file', f, f.name);
      fd.append('felhasznalo', this.felhasznalo);
      try {
        await firstValueFrom(this.http.post(`/api/uzenet/csatolmany/${messageId}`, fd));
      } catch (e: any) {
        this.data.sendToast(`A(z) ${f.name} feltöltése nem sikerült.`, 'error');
      }
    }
  }

  /*  A partnertörzs a címzett-választóhoz. Csak akkor kérjük le, ha tényleg kell –
   *  a legtöbb üzenet belső, annak ehhez semmi köze. */
  /*  A PARTNERTÖRZS KELL, NEM A „PARTNEREK" LISTA.
   *
   *  Az előbbi visszaadja a KAPCSOLATI KÓDOT és a KRID-et is – enélkül a képernyő
   *  mindenkire azt írta, hogy nincs kapcsolati kódja (a mező egyszerűen nem jött meg),
   *  és a szervezetek is csak „javaslatként" jelentek volna meg, azaz sehogy. */
  async hkPartnerekBetolt() {
    if (this.hkPartnerek.length) return;
    try {
      const r: any = await firstValueFrom(this.http.get(
        `/api/iktatgato/partnertorzs/${this.intezmenyId}`));
      this.hkPartnerek = Array.isArray(r) ? r : (r?.partnerek || []);
    } catch (e) {
      this.hkPartnerek = [];
    }
  }

  /*  Megcímezhető-e: személynél kapcsolati kód kell, szervezetnél KRID VAGY hivatali
   *  kapu rövidnév – a specifikáció mindkettőt elfogadja címzésre, és a rövidnév az,
   *  ami a hivatalok közt ténylegesen kéznél van. */
  hkCimezheto(p: any): boolean {
    return p?.tipus === 'szemely' ? !!p?.kapcsolati_kod : !!(p?.krid || p?.rovidnev);
  }

  hkPartnerAllapot(p: any): string {
    if (p?.tipus === 'szemely') {
      return p?.kapcsolati_kod ? 'kapcsolati kód megvan' : 'nincs kapcsolati kódja';
    }
    if (p?.krid) return `KRID: ${p.krid}`;
    if (p?.rovidnev) return `rövid név: ${p.rovidnev}`;
    return 'nincs KRID-je és rövid neve sem';
  }

  /*  A szűrő NÉLKÜL is mutatunk listát: a partnertörzs jellemzően pár tucat sor, és aki
   *  nem tudja fejből a nevet, annak a puszta keresőmező semmit nem ad. A megcímezhetők
   *  kerülnek előre – azokkal lehet ténylegesen küldeni. */
  get hkPartnerLista(): any[] {
    const sz = this.hkPartnerSzuro.trim().toLowerCase();
    const lista = sz
      ? this.hkPartnerek.filter((p) => `${p.nev || ''} ${p.krid || ''} ${p.rovidnev || ''}`
        .toLowerCase().includes(sz))
      : this.hkPartnerek;
    return [...lista]
      .sort((a, b) => Number(this.hkCimezheto(b)) - Number(this.hkCimezheto(a)))
      .slice(0, 60);
  }

  hkFajlValaszt(esemeny: any) {
    const f = esemeny?.target?.files?.[0] || null;
    this.hkFajl = f;
  }

  /** A fájl base64-ben megy: nem kell külön feltöltő-út, és nálunk nem kerül lemezre. */
  private fajlBase64(f: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const olvaso = new FileReader();
      olvaso.onload = () => {
        const s = String(olvaso.result || '');
        resolve(s.includes(',') ? s.split(',')[1] : s);
      };
      olvaso.onerror = () => reject(new Error('A fájl nem olvasható.'));
      olvaso.readAsDataURL(f);
    });
  }

  async kuldHivataliKapu() {
    if (!this.hk.targy?.trim()) { this.data.sendToast('A tárgy megadása kötelező.', 'warning'); return; }
    if (!this.hkFajl) {
      this.data.sendToast('A hivatali kapu dokumentumot továbbít – csatolj egy fájlt.', 'warning');
      return;
    }
    if (!this.hk.partner_id && !this.hk.krid?.trim() && !this.hk.cimzett_rovidnev?.trim()
        && !this.hk.kapcsolati_kod?.trim()) {
      this.data.sendToast('Válassz címzettet, vagy add meg a hivatali kapu rövid nevét, '
        + 'a KRID-et vagy a kapcsolati kódot.', 'warning');
      return;
    }
    this.kuldes = true;
    this.hkEredmeny = null;
    try {
      const base64 = await this.fajlBase64(this.hkFajl);
      const r: any = await firstValueFrom(this.http.post(
        `/api/iktatgato/bksz/uzenet/${this.intezmenyId}`, {
          partner_id: this.hk.partner_id || undefined,
          krid: this.hk.krid?.trim() || undefined,
          cimzett_rovidnev: this.hk.cimzett_rovidnev?.trim() || undefined,
          kapcsolati_kod: this.hk.kapcsolati_kod?.trim() || undefined,
          targy: this.hk.targy.trim(),
          iktatoszam: this.hk.iktatoszam?.trim() || undefined,
          fajl_nev: this.hkFajl.name,
          fajl_base64: base64,
        }));
      if (r?.ok) {
        this.hkEredmeny = { ok: true, szoveg: `Feladva. Érkeztetési szám: ${r.erkeztetesi_szam}` };
        this.data.sendToast('A küldemény feladva a hivatali kapun.', 'success');
        this.hk = { partner_id: '', krid: '', cimzett_rovidnev: '', kapcsolati_kod: '',
          targy: '', iktatoszam: '' };
        this.hkFajl = null;
      } else {
        const h = r?.hiba;
        /*  „Nem adott érkeztetési számot" önmagában semmit nem mond. Ha a szolgáltatás
         *  felismert hibakódot küldött, azt mutatjuk; ha nem, akkor a NYERS választ és
         *  azt, hogy MIT küldtünk – a leggyakoribb ok a rosszul megadott dokumentumtípus. */
        const reszletek = [
          h ? `${h.kod ? h.kod + ' – ' : ''}${h.szoveg || ''} ${h.magyarazat || ''}`.trim() : '',
          /*  A HIBA A VÁLASZ VÉGÉN VAN (a form-válaszban), ezért a 600 karakteres levágás
           *  pont azt vitte el, amiért a nyers választ megmutatjuk. */
          !h && r?.nyers ? `A szolgáltatás válasza: ${String(r.nyers)}` : '',
          r?.http_statusz ? `HTTP ${r.http_statusz}` : '',
          r?.kuldott ? `Feladó: ${r.kuldott.felado || '(nincs)'} · dokumentumtípus: `
            + `${r.kuldott.doktipus?.hivatal || '(üres)'} / ${r.kuldott.doktipus?.azonosito || '(üres)'}`
            + ` · cím: ${r.kuldott.url || ''}` : '',
          /*  A gateway belépési pontja is dönthet: a specifikáció `/process`-re végződő
           *  címet ad, a hivatalos mintakliens viszont a `/process` nélkülire küld. */
          (r?.probak || []).length > 1
            ? 'Próbált címek:\n' + r.probak.map((x: any) =>
                `  ${x.erkeztetes ? '✔' : '✘'} ${x.url}${x.http ? ` · HTTP ${x.http}` : ''}`
                + `${x.hiba ? ` · ${x.hiba}` : ''}`).join('\n')
            : '',
        ].filter(Boolean);
        this.hkEredmeny = { ok: false,
          szoveg: reszletek.join('\n') || 'A szolgáltatás nem adott érkeztetési számot.' };
      }
    } catch (e: any) {
      this.hkEredmeny = { ok: false, szoveg: e?.error?.error || 'A küldés nem sikerült.' };
    } finally {
      this.kuldes = false;
    }
  }

  async kuld() {
    if (!this.uj.cimzettek.length) { this.data.sendToast('Adj meg legalább egy címzettet.', 'warning'); return; }
    if (!this.uj.uzenet?.trim()) { this.data.sendToast('Az üzenet nem lehet üres.', 'warning'); return; }

    /*  NAGY KÖRNÉL VISSZAKÉRDEZÜNK. A körüzenet nem vonható vissza: ha egyszer
     *  kiment háromszáz szülőnek, akkor kiment. A húszas határ azért van itt, mert egy
     *  osztálynyi címzett még rutinmunka, egy évfolyamnyi már nem. */
    const db = this.becsultCimzettDb;
    if (db >= 20) {
      const kik = this.uj.cimzettek.map((c: any) => c.nev || c.azonosito).join(', ');
      if (!confirm(`Az üzenet körülbelül ${db} címzetthez megy ki (${kik}).\n\n`
        + 'A kiküldött üzenet nem vonható vissza. Elküldöd?')) return;
    }

    this.kuldes = true;
    try {
      const r: any = await firstValueFrom(this.http.post(`/api/uzenet/kuldes/${this.intezmenyId}`, {
        mod: this.loginMode, felhasznalo: this.felhasznalo,
        targy: this.uj.targy, uzenet: this.uj.uzenet, cimzettek: this.uj.cimzettek,
      }));
      if (this.csatolando.length) await this.csatolmanyokFeltolt(r.id, this.csatolando);
      if (this.megosztandoFelvetel?.id) await this.felvetelCsatol(r.id, this.megosztandoFelvetel);
      this.data.sendToast(`Elküldve ${r?.cimzett_db || 0} címzettnek.`, 'success');
      this.ujNyitva = false;
      this.uj = { targy: '', uzenet: '', cimzettek: [] };
      this.csatolando = [];
      this.megosztandoFelvetel = null;
      this.ujLink = null;
      await this.betolt();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A küldés nem sikerült.', 'error');
    } finally {
      this.kuldes = false;
    }
  }

  /**
   *  A felvétel HIVATKOZÁSKÉNT kerül a levélre, nem másolatként: egy órás értekezlet
   *  több száz megabájt, amit sem feltölteni nem lehetne (25 MB a határ), sem lemásolni
   *  nem volna értelme. A címzettek ugyanazt az egy fájlt nézik vissza.
   */
  private async felvetelCsatol(messageId: string, felvetel: any) {
    try {
      await firstValueFrom(this.http.post(`/api/uzenet/csatolmany-felvetel/${messageId}`, {
        felhasznalo: this.felhasznalo, felvetel: felvetel.id, intezmeny: this.intezmenyId,
      }));
    } catch (e: any) {
      this.data.sendToast(e?.error?.error
        || 'Az üzenet elment, de a felvételt nem sikerült hozzácsatolni.', 'error');
    }
  }

  felvetelMegosztasElvet() {
    this.megosztandoFelvetel = null;
  }

  /** A szál többi résztvevője, akinek a szerepkörömmel válaszolhatok. */
  get valaszJeloltek(): any[] { return this.kivalasztott?.valasz_jeloltek || []; }

  /** Több emberes szál-e: csak ilyenkor van értelme választani, kinek megy a válasz. */
  get tobbResztvevo(): boolean { return this.valaszJeloltek.length > 1; }

  valasztottValt(azonosito: string, be: boolean) {
    this.valaszValasztottak = be
      ? [...new Set([...this.valaszValasztottak, azonosito])]
      : this.valaszValasztottak.filter((x) => x !== azonosito);
  }

  /** A ténylegesen megcímzett emberek a választás szerint. Üres = a szerver dönt (mind). */
  private valaszCimzettek(): string[] | null {
    if (this.valaszMod === 'mind') return null;
    if (this.valaszMod === 'felado') {
      return this.kivalasztott?.felado ? [this.kivalasztott.felado] : null;
    }
    return this.valaszValasztottak;
  }

  get valaszCimkeSzoveg(): string {
    if (this.valaszMod === 'felado') {
      return this.kivalasztott?.felado_nev
        || this.valaszJeloltek.find((x: any) => x.azonosito === this.kivalasztott?.felado)?.nev
        || 'a feladónak';
    }
    if (this.valaszMod === 'valasztott') return `${this.valaszValasztottak.length} kiválasztott`;
    return `mind (${this.valaszJeloltek.length})`;
  }

  async valaszKuld() {
    if (!this.valasz.trim()) { this.data.sendToast('A válasz nem lehet üres.', 'warning'); return; }
    const utolso = this.kivalasztott?.uzenetek?.[this.kivalasztott.uzenetek.length - 1];
    if (!utolso) return;
    const cimzettek = this.valaszCimzettek();
    if (this.valaszMod === 'valasztott' && !cimzettek?.length) {
      this.data.sendToast('Jelöld ki, kinek megy a válasz.', 'warning');
      return;
    }
    this.kuldes = true;
    try {
      const r: any = await firstValueFrom(this.http.post(`/api/uzenet/kuldes/${this.intezmenyId}`, {
        mod: this.loginMode, felhasznalo: this.felhasznalo,
        uzenet: this.valasz, valasz_erre: utolso.id,
        valasz_cimzettek: cimzettek || undefined,
      }));
      if (this.valaszCsatolando.length) await this.csatolmanyokFeltolt(r.id, this.valaszCsatolando);
      this.valasz = '';
      this.valaszCsatolando = [];
      this.valaszLink = null;
      await this.megnyit({ szal: this.kivalasztott.szal });
      this.data.sendToast(`Válasz elküldve ${r?.cimzett_db || 0} címzettnek.`, 'success');
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A válasz küldése nem sikerült.', 'error');
    } finally {
      this.kuldes = false;
    }
  }

  /*  A fájl a TOKENES megnyitóval nyílik. A linkes megnyitás nem viszi a belépési jegyet,
   *  a kiszolgáló pedig – helyesen – nem ad ki fájlt kilét nélkül. */
  fajlNyit(url: string, nev?: string) { this.data.megnyitFajl(url, nev || 'Csatolmány'); }

  csatolmanyUrl(cs: any) {
    return `/api/uzenet/csatolmany/${cs.id}/letoltes?felhasznalo=${encodeURIComponent(this.felhasznalo)}`;
  }

  /*  A `<video src>` nem visz tokent: csatolmányonként egyszer tokennel kérünk egy rövid
   *  életű jegyet, és az kerül a videó címébe. Amíg nincs meg, a lejátszó nem jelenik meg. */
  private videoCimek: Record<string, string | null> = {};

  videoCim(cs: any): string | null {
    if (!(cs.id in this.videoCimek)) {
      this.videoCimek[cs.id] = null;
      firstValueFrom(this.http.get(`/api/uzenet/csatolmany/${cs.id}/jegy`,
        { params: { felhasznalo: this.felhasznalo } }))
        .then((v: any) => { this.videoCimek[cs.id] = `${this.csatolmanyUrl(cs)}&jegy=${encodeURIComponent(v?.jegy || '')}`; })
        .catch(() => { /* nincs joga vagy nem elérhető: a lejátszó nem jelenik meg (újrapróbálás nincs, különben minden frissítés új kérés) */ });
    }
    return this.videoCimek[cs.id];
  }

  /**
   *  Saját üzenet-e. Ékezet- és kisbetű-érzéketlenül, ahogy az adatbázis is nézi:
   *  a régi adatokban a felhasználónév ékezetes („blaha.péter"), a bejelentkezésé
   *  gyakran nem – szigorú összehasonlítással a saját üzenet idegennek látszana.
   */
  sajat(u: any) {
    const norm = (v: any) => String(v ?? '').trim().toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return !!norm(u?.kuldo) && norm(u?.kuldo) === norm(this.felhasznalo);
  }

  meret(b: number) {
    if (!b) return '';
    return b < 1024 ? `${b} B` : b < 1048576 ? `${Math.round(b / 1024)} KB` : `${(b / 1048576).toFixed(1)} MB`;
  }

  /* ── linkek és előnézet ─────────────────────────────────────────────────── */

  /*  MI SZÁMÍT LINKNEK.
   *
   *  Nem csak a teljes, „https://"-sel kezdődő cím: a valóságban senki nem így ír.
   *  A <b>www.valami.hu</b> és a puszta <b>valami.hu/oldal</b> ugyanúgy link — a
   *  csevegőkben is az. A puszta címnél viszont nem elég a „pont + betűk" minta, mert
   *  a magyar szöveg tele van ilyennel („stb.holnap", „pl.azért"): ezért a végződésnek
   *  egy VALÓDI, ismert tartományvégnek kell lennie. Így a mondatközi rövidítésből nem
   *  lesz link, a beírt címből viszont igen.
   */
  /*  A TÖBBTAGÚ VÉGZŐDÉS ÁLL ELÖL (`co.uk` a `uk` előtt), különben a rövidebb nyelné
   *  el. Fájlnév-kiterjesztés (pdf, doc, png) SZÁNDÉKOSAN nincs benne: a „jelentes.pdf"
   *  nem webcím, és linkként felkínálva csak hibára vinné a címzettet. */
  private static readonly TARTOMANYVEG =
    'co\\.uk|hu|com|org|net|edu|gov|eu|info|io|dev|app|uk|de|at|sk|ro|rs|ua|hr|si|pl|cz|'
    + 'fr|it|es|nl|se|no|dk|fi|ch|be|ie|pt|gr|tv|me|cc|xyz|online|site|shop|blog|news|tech|cloud';

  private static linkMinta(): RegExp {
    //  1. teljes cím sémával   2. www.…   3. puszta tartomány ismert végződéssel
    return new RegExp(
      '(https?:\\/\\/[^\\s<>"\']+'
      + '|www\\.[^\\s<>"\']+'
      + `|\\b[a-z0-9](?:[a-z0-9-]*[a-z0-9])?(?:\\.[a-z0-9-]+)*\\.(?:${UzenetekComponent.TARTOMANYVEG})(?:\\/[^\\s<>"\']*)?)`,
      'gi');
  }

  /** Séma nélkül beírt címhez odatesszük a https-t – enélkül a böngésző relatív útnak veszi. */
  private static teljesCim(url: string): string {
    return /^https?:\/\//i.test(url) ? url : `https://${url}`;
  }

  /**
   *  Az üzenet szövege darabokra bontva: sima szöveg és kattintható link váltakozva.
   *
   *  A szöveget SOSEM adjuk át HTML-ként (innerHTML): aki üzenetet ír, az akkor a
   *  képernyőre is írhatna – szkriptet, hamis belépő űrlapot. Ezért a sablon minden
   *  darabot külön, szövegként rajzol ki, és csak a linkből lesz `<a>`.
   *
   *  A mondatvégi írásjel nem tartozik a címhez: a „nézd meg: pelda.hu/cikk." linkje a
   *  ponttal együtt hibára futna.
   */
  szovegDarabok(szoveg: string): any[] {
    const t = String(szoveg ?? '');
    if (!t) return [];
    const minta = UzenetekComponent.linkMinta();
    const ki: any[] = [];
    let hol = 0;
    let talalat: RegExpExecArray | null;
    while ((talalat = minta.exec(t)) !== null) {
      let url = talalat[0];
      const vege = url.match(/[.,;:!?)\]]+$/);
      if (vege) url = url.slice(0, url.length - vege[0].length);

      /*  AZ E-MAIL CÍM NEM WEBCÍM. A „titkar@zenitiskola.hu" végén ott a tartomány, így
       *  a minta ráillik – linkként viszont a levélcím helyett egy weboldalra vinné a
       *  címzettet. Ha a találat előtt kukac áll, szöveg marad. (Visszatekintő mintát
       *  szándékosan nem használunk: régebbi iOS-en az egész minta elszállna tőle.) */
      if (t[talalat.index - 1] === '@') {
        minta.lastIndex = talalat.index + url.length;
        continue;
      }

      if (talalat.index > hol) ki.push({ text: t.slice(hol, talalat.index) });
      ki.push({ text: url, url: UzenetekComponent.teljesCim(url) });
      hol = talalat.index + url.length;
      minta.lastIndex = hol;
    }
    if (hol < t.length) ki.push({ text: t.slice(hol) });
    return ki;
  }

  /** HTML-e a szöveg (a rendszerüzenetek <p>/<b>/<ul>… címkékkel készülnek). */
  private static htmlE(s: string): boolean {
    return /<(p|br|b|strong|i|em|ul|ol|li|div|table|h[1-6]|a)[\s>/]/i.test(String(s || ''));
  }

  /** A lista egysoros előnézetéhez: a rendszerüzenet címkéi nélkül, szóközökkel. */
  htmlNelkul(s: string | null | undefined): string {
    return String(s || '').replace(/<(br|\/p|\/li|\/div|\/h[1-6])\s*\/?>/gi, ' ').replace(/<[^>]*>/g, '')
      .replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/\s+/g, ' ').trim();
  }

  /** A szövegben talált első link – ennyi kell az előnézethez. */
  private elsoLink(szoveg: string): string | null {
    return this.szovegDarabok(szoveg).find((d: any) => d.url)?.url || null;
  }

  /*  ÍRÁS KÖZBENI ELŐNÉZET.
   *
   *  A kártya ne csak elküldés után derüljön ki: a feladó lássa, mit fog látni a
   *  címzett. Viszont NEM minden leütésnél kérdezünk: a félig begépelt cím („https://i")
   *  értelmetlen lekérés lenne, és a gyorsítótárba is bekerülne hibaként. Ezért a
   *  gépelés elültével, háromnegyed másodperccel később nézünk utána. */
  linkFigyel(hova: 'uj' | 'valasz') {
    clearTimeout(this.linkIdozito);
    this.linkIdozito = setTimeout(() => {
      if (hova === 'uj') this.ujLink = this.elsoLink(this.uj?.uzenet || '');
      else this.valaszLink = this.elsoLink(this.valasz || '');
    }, 750);
  }

  /**
   *  A linkhez tartozó kártya adatai, ha már megjöttek.
   *
   *  Az ELSŐ hívás elindítja a lekérést és `null`-lal tér vissza (a sablon ilyenkor nem
   *  rajzol semmit); amikor megjön a válasz, a változásfigyelés magától újrarajzolja.
   *  A térkép azért kell, hogy ugyanaz a link ne induljon el újra és újra.
   */
  elonezet(url: string): any {
    if (!url) return null;
    if (this.elonezetek.has(url)) return this.elonezetek.get(url) || null;
    this.elonezetek.set(url, null);
    firstValueFrom(this.http.get(`/api/link-elonezet?url=${encodeURIComponent(url)}`))
      .then((r: any) => this.elonezetek.set(url, r?.talalt ? r : false))
      .catch(() => this.elonezetek.set(url, false));
    return null;
  }

  /* ── Elküldött üzenet javítása ───────────────────────────────────────────── */

  szerkesztesInditasa(u: any) {
    this.szerkesztettId = u?.id || null;
    this.szerkesztettSzoveg = String(u?.uzenet ?? '');
  }

  szerkesztesMegse() {
    this.szerkesztettId = null;
    this.szerkesztettSzoveg = '';
  }

  async szerkesztesMentes(u: any) {
    const ujSzoveg = this.szerkesztettSzoveg.trim();
    if (!ujSzoveg) { this.data.sendToast('Az üzenet nem lehet üres.', 'warning'); return; }
    if (ujSzoveg === String(u?.uzenet ?? '').trim()) { this.szerkesztesMegse(); return; }

    /*  AKI MÁR OLVASTA, AZ MÁR OLVASTA. Az olvasatlan üzenet javítása ártalmatlan;
     *  ha viszont a címzettek egy része már látta az eredetit, azt a feladó tudja meg
     *  a mentés ELŐTT – utólag nem lehet „nem elküldötté" tenni. */
    if (u?.olvasta_db > 0
      && !confirm(`Ezt az üzenetet már ${u.olvasta_db} címzett elolvasta.\n\n`
        + 'A javítás után „szerkesztve" jelzés kerül rá, és az eredeti szöveg a naplóban marad. Folytatod?')) return;

    this.szerkesztesFolyamatban = true;
    try {
      await firstValueFrom(this.http.post(`/api/uzenet/modositas/${u.id}`, {
        felhasznalo: this.felhasznalo, uzenet: ujSzoveg,
      }));
      //  Helyben is frissítjük, hogy a buborék azonnal a javított szöveget mutassa.
      u.uzenet = ujSzoveg;
      u.modositva = new Date();
      u._darabok = this.szovegDarabok(ujSzoveg);
      u._link = u._darabok.find((d: any) => d.url)?.url || null;
      this.szerkesztesMegse();
      this.data.sendToast('Az üzenet javítva.', 'success');
      await this.betolt();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A javítás nem sikerült.', 'error');
    } finally {
      this.szerkesztesFolyamatban = false;
    }
  }

  /**
   *  Csatolmány visszavétele. A FELTÖLTÖTT fájl a tárból is kikerül – enélkül a link
   *  élne tovább. A megosztott értekezlet-felvételt csak leakasztjuk: az a fájl nem
   *  ezé a levélé, hanem az iskola felvétel-nyilvántartásáé.
   */
  async csatolmanyTorles(u: any, cs: any) {
    const hivatkozott = !!cs?.forras;
    const kerdes = hivatkozott
      ? `Leveszed a levélről ezt a megosztott felvételt?\n\n${cs.fajlnev}\n\n`
        + 'A felvétel megmarad az Értekezlet képernyőn, csak a címzettek nem érik el többé innen.'
      : `Biztosan visszaveszed ezt a csatolmányt?\n\n${cs.fajlnev}\n\n`
        + 'A fájl a tárból is törlődik, a címzettek nem tudják megnyitni. Ez nem vonható vissza.'
        + (u?.olvasta_db > 0 ? `\n\nAz üzenetet már ${u.olvasta_db} címzett elolvasta.` : '');
    if (!confirm(kerdes)) return;

    try {
      await firstValueFrom(this.http.delete(
        `/api/uzenet/csatolmany/${cs.id}?felhasznalo=${encodeURIComponent(this.felhasznalo)}`));
      u.csatolmanyok = (u.csatolmanyok || []).filter((x: any) => x.id !== cs.id);
      u.modositva = new Date();
      this.data.sendToast(hivatkozott ? 'A felvétel levéve a levélről.' : 'A csatolmány visszavéve.', 'success');
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A csatolmány visszavétele nem sikerült.', 'error');
    }
  }

  /** Helyben lejátszható-e a csatolmány (videó, hang) – ilyenkor lejátszót teszünk ki. */
  videoE(cs: any): boolean {
    return /^(video|audio)\//.test(String(cs?.tipus || ''));
  }

  /** Ugyanaz a cím, de letöltésre kényszerítve – a videó mellé, „Letöltés" gombnak. */
  csatolmanyLetoltesUrl(cs: any) {
    return `${this.csatolmanyUrl(cs)}&letoltes=1`;
  }
}
